/**
 * An object to hold url search params that are used throughout S3G
 */
export default {
  get ReturnUrl() {
    return 'return_url';
  },
};
